/**
* moved the map build in assets/js/projects-gmap.js to handle the new maps API loading with callback
* https://developers.google.com/maps/documentation/javascript/load-maps-js-api
**/
//- place markers on the map depending on the projects list
if ($('#projects').length) {
  $(function () {
    $.each(sortedProjects, function (country, regions) {
      $.each(regions, function (region, sectors) {
        $.each(sectors, function (sector, projects) {
          $.each(projects, function (id, project) {
            var projectDesc = projectInfoWindow(project.title, project.amount, project.grade, project.rate, project.slug);
            if ($.inArray(id, confidentialPostsIds) < 0) {
              newMarker(parseFloat(project.lat), parseFloat(project.lng), map, id, icon, '', null, 0, projectDesc);
            }
          });
        });
      });
    });
  })
}
